export enum PlansPrice {
  LITE = "$0",
  STARTER = "$99",
  PLUS = "$199",
  ULTRA = "$349",
  STARTER_ANNUALLY = "$1099",
  PLUS_ANNUALLY = "$2199",
  ULTRA_ANNUALLY = "$3999",
}
